import { createAction } from '@reduxjs/toolkit';

export const openModal = createAction('modal/openModal');
export const closeModal = createAction('modal/closeModal');
